import { createFileRoute } from '@tanstack/react-router';
import DailyTasks from '../components/DailyTasks';

export const Route = createFileRoute('/daily-tasks')({
  component: () => <DailyTasks />,
});





